import { useCallback, useState } from 'react';

export function useBooleanState(init:boolean) {
    const [value, setState] = useState(init)
    const setTrue = useCallback(() => setState(true), []);
    const setFalse = useCallback(() => setState(false), []);
    const toggle = useCallback(() => setState(state => !state), [])

    return [value, setTrue, setFalse, toggle] as const
}